import React from 'react'
import ReactDOM from 'react-dom/client'
import App from './App'
import { installGlobalErrorLogging } from './services/errorLogService'
import './index.css'

installGlobalErrorLogging()

ReactDOM.createRoot(document.getElementById('root')!).render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
)
